import * as React from 'react';
import Typography from '@mui/material/Typography';
import { app } from '../../config/app.js';
import { EsamiCandidato } from '../../config/collections/candidati.js';

import { useLocation } from 'react-router-dom';
export default function EsamiCandidatoComponent(props) {
  const user=props.user;
  const location=useLocation();
  const httpdata = location.state && location.state.data;
  const candidatoData = (httpdata && httpdata.candidato ? httpdata.candidato : null);
  const docData={...candidatoData.docData,id:candidatoData.id};
  return (
   <div><Typography sx={{ mb: 2 }} variant="h6">Scheda di <b>{candidatoData.nome} {candidatoData.cognome}</b> (Cat. {app.category[candidatoData.categoria]})</Typography>

         
        <EsamiCandidato docData={docData} user={user} id={candidatoData.id} />
            
       
   </div>
      
  );
}